/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RoutesAliases {
  FRAGMENT_ASSIGN_PRIVACY_WARNING = 'fragment-assign-privacy-warning',
  FRAGMENT_MY_DATA = 'fragment-my-data',
  FRAGMENT_PRIVACY = 'fragment-privacy',
  FRAGMENT_TECHNICIAL_VISITS_DETAILS = 'fragment-technicial-visits-details',
  FRAGMENT_TERM_USE = 'fragment-term-use',
  FRAGMENT_VISIT = 'fragment-visit',
  FRAGMENT_VISIT_FORMS = 'fragment-visit-forms',
  LAYOUT_0 = 'layout-0',
  ROUTE_ASSIGN_PRIVACY_WARNING = 'route-assign-privacy-warning ',
  ROUTE_ASSIGN_TERM_USE = 'route-assign-term-use',
  ROUTE_MY_DATA = 'route-my-data',
  ROUTE_PRIVACY = 'route-privacy',
  ROUTE_TECHNICAL_VISIT = 'route-technical-visit',
  ROUTE_TECHNICAL_VISIT_DETAILS = 'route-technical-visit-details',
  ROUTE_TECHNICAL_VISIT_FORMS = 'route-technical-visit-forms',
}
export { RoutesAliases };
